const styles = {
  root: {
    minHeight: '70vh',
  },
};

export default styles;
